/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes, {
    array, bool, func, object,
} from 'prop-types';

// Material UI
import Grid from '@material-ui/core/Grid';

// Checkout UI
import Calendar from './Calendar';

const CalendarView = ({
    calendarDisplayData,
    getMediumDayFormat,
    getIconPlaceholder,
    onClickCalNext,
    onClickCalPrev,
    onSelectedDate,
    overWriteDateComponent,
    selectedDates,
}) => {
    const showNavBtnFrYear = Object.keys(calendarDisplayData).sort()[0];
    const showNavBtnFrMonth = Object.keys(calendarDisplayData[showNavBtnFrYear]).sort()[0];

    return (
        <Grid id="calendar-view" container>
            {
                Object.keys(calendarDisplayData).sort().map((year) => (
                    <Calendar
                        key={year}
                        year={year}
                        calendarData={calendarDisplayData}
                        showNavBtnFrYear={showNavBtnFrYear}
                        showNavBtnFrMonth={showNavBtnFrMonth}
                        onClickCalNext={onClickCalNext}
                        onClickCalPrev={onClickCalPrev}
                        onSelectedDate={onSelectedDate}
                        overWriteDateComponent={overWriteDateComponent}
                        selectedDates={selectedDates}
                        getMediumDayFormat={getMediumDayFormat}
                        getIconPlaceholder={getIconPlaceholder}
                    />
                ))
            }
        </Grid>
    );
};

CalendarView.propTypes = {
    calendarDisplayData: object.isRequired,
    getMediumDayFormat: bool.isRequired,
    getIconPlaceholder: bool.isRequired,
    onClickCalNext: func.isRequired,
    onClickCalPrev: func.isRequired,
    onSelectedDate: func.isRequired,
    overWriteDateComponent: func.isRequired,
    selectedDates: array.isRequired,
};

export default CalendarView;
